module.exports = __webpack_public_path__ + "static/img/userule4.74442f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userule4.jpg
// module id = nUW1
// module chunks = 0